//LES SERVICES API
let prefix = "/cotation";
export const GET_MY_COTATION_DATA_TABLE = prefix + "/get-my-cotations";
export const GET_MY_COTATION_DEVIS = prefix + "/get-my-devis";

export const GET_FILTER_MENU = "/config/get-filter-menu-famille";

export const REQUIREMENTS = prefix + "/requirements";
export const SEARCH_ARTICLE = prefix + "/search-article";
export const STORE = prefix + "/store";
export const GET = prefix + "/get";
export const UPDATE = prefix + "/update";
export const DELETE = prefix + "/destroy";

export const COTATION_TO_PDF = prefix + "/cotation-to-pdf";

export const T_DEVIS_TO_PDF = prefix + "/devis/t/devis-to-pdf";
export const O_DEVIS_TO_PDF = prefix + "/devis/o/devis-to-pdf";
